import Support from './Support';
import Activation from './Activation';
import Features from './Features';
import Title from './Title';

const StockwizLandingPage = () => {
  return (
    <div className="stockwiz-landing">
      <div className="container-fluid">
        <main className="row stockwiz-landing__container">
          <div className="col-lg-6 col-md-12 col-sm-12 ">
            <Title />
            <Features />
            <Activation />
            <Support />
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 half-image-container">
            <img src="/b2b/stockwiz/img.png" alt="App Preview" />
          </div>
        </main>
      </div>
    </div>
  );
};

export default StockwizLandingPage;
